import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { cn } from "../../../../utils/classnames";
import { getFilterSelectStyles } from "../utils";
import {
  ChevronDownIcon,
  SearchIcon,
  SelectDropdownIndicator,
} from "./Icons";

const STATUS_OPTIONS = [
  { value: "PENDING_APPROVAL", label: "Request Pending" },
  { value: "APPROVED", label: "Request Approved" },
  { value: "REJECTED", label: "Request Rejected" },
  { value: "UPDATED", label: "Updated (Unconfirmed Booking)" },
  { value: "DRAFT", label: "Draft" },
];

const USER_TYPE_OPTIONS = [
  { value: "individual", label: "Regular User" },
  { value: "business", label: "Business User" },
];

const DEFAULT_DATE_RANGE_SETTINGS = {
  startDate: moment("2025-10-01"),
  endDate: moment("2025-12-31"),
};

const SelectField = ({
  label,
  value,
  onChange,
  options,
}) => (
  <div>
    <div className="tw:mb-2 tw:text-[14px] tw:leading-5 tw:text-[#7C7B7B]">{label}</div>
    <Select
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Select..."
      isSearchable={false}
      styles={getFilterSelectStyles(!!value)}
      components={{ DropdownIndicator: SelectDropdownIndicator, IndicatorSeparator: null }}
    />
  </div>
);

const FiltersPanel = ({
  search,
  setSearch,
  showFilters,
  setShowFilters,
  selectedStatus,
  setSelectedStatus,
  selectedUserType,
  setSelectedUserType,
  selectedAdmin,
  setSelectedAdmin,
  adminOptions,
  requestedDateRange,
  requestedDateText,
  onRequestedDateChange,
  onClearFilters,
  filterHandler,
}) => (
  <section className="tw:mt-[32px] tw:flex tw:flex-col tw:gap-2">
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-2">
      <div className="tw:flex tw:h-[45px] tw:w-full tw:max-w-[329px] tw:items-center tw:gap-[10px] tw:rounded-[5px] tw:border tw:border-[#D9D9D9] tw:bg-white tw:pl-[15px] tw:pr-[19px]">
        <SearchIcon />
        <input
          type="text"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search"
          className="tw:h-full tw:w-full tw:border-0 tw:bg-transparent tw:p-0 tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:outline-none"
        />
      </div>

      <button
        type="button"
        className="tw:border-0 tw:bg-transparent tw:p-0"
        onClick={() => setShowFilters((prev) => !prev)}
      >
        <span className="tw:flex tw:h-[45px] tw:w-[108px] tw:items-center tw:justify-between tw:rounded-[5px] tw:bg-[#282828] tw:px-[17px] tw:text-white tw:font-hanken-grotesk">
          <span className="tw:text-[15px] tw:leading-[22px]">Filter</span>
          <span className="tw:font-['Noto_Serif_JP'] tw:text-[14px] tw:font-bold">{showFilters ? "-" : "+"}</span>
        </span>
      </button>
    </div>

    {showFilters ? (
      <div className="tw:rounded-[5px] tw:bg-[#F9F9F9] tw:p-5">
        <div className="tw:grid tw:grid-cols-1 tw:gap-3 tw:md:grid-cols-2 tw:xl:grid-cols-4">
          <SelectField
            label="Status"
            value={selectedStatus}
            onChange={setSelectedStatus}
            options={STATUS_OPTIONS}
          />

          <SelectField
            label="User Type"
            value={selectedUserType}
            onChange={setSelectedUserType}
            options={USER_TYPE_OPTIONS}
          />

          <div>
            <div className="tw:mb-2 tw:text-[14px] tw:leading-5 tw:text-[#7C7B7B]">Requested Date</div>
            <div className="tw:relative">
              <DateRangePicker
                onCallback={onRequestedDateChange}
                initialSettings={requestedDateRange || DEFAULT_DATE_RANGE_SETTINGS}
              >
                <input
                  type="text"
                  readOnly
                  value={requestedDateText}
                  placeholder="Select..."
                  className={cn(
                    "tw:h-[45px] tw:w-full tw:rounded-[5px] tw:border tw:border-[#D9D9D9] tw:bg-white tw:px-[15px] tw:pr-[34px] tw:text-[15px] tw:leading-[22px] placeholder:tw:text-[#7C7B7B]",
                    requestedDateRange ? "tw:!text-[#282828]" : "tw:!text-[#7C7B7B]",
                  )}
                />
              </DateRangePicker>
              <div className="tw:pointer-events-none tw:absolute tw:right-[15px] tw:top-1/2 tw:-translate-y-1/2">
                <ChevronDownIcon />
              </div>
            </div>
          </div>

          <div>
            <div className="tw:mb-2 tw:text-[14px] tw:leading-5 tw:text-[#7C7B7B]">Admin</div>
            <Select
              value={selectedAdmin}
              onChange={setSelectedAdmin}
              options={adminOptions}
              placeholder="Select..."
              isSearchable={true}
              styles={getFilterSelectStyles(!!selectedAdmin)}
              components={{ DropdownIndicator: SelectDropdownIndicator, IndicatorSeparator: null }}
            />
          </div>
        </div>

        <div className="tw:mt-5 tw:flex tw:items-center tw:gap-2">
          <button
            type="button"
            className="tw:border-0 tw:bg-transparent tw:p-0"
            onClick={() => filterHandler()}
          >
            <span className="tw:flex tw:h-[45px] tw:w-[120px] tw:items-center tw:justify-center tw:rounded-[5px] tw:bg-[#282828] tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-white tw:font-hanken-grotesk">
              Apply
            </span>
          </button>
          <button
            type="button"
            className="tw:border-0 tw:bg-transparent tw:p-0"
            onClick={onClearFilters}
          >
            <span className="tw:flex tw:h-[45px] tw:w-[120px] tw:items-center tw:justify-center tw:rounded-[5px] tw:border tw:border-[#282828] tw:bg-white tw:text-[15px] tw:leading-[22px] tw:text-[#282828] tw:font-hanken-grotesk">
              Clear
            </span>
          </button>
        </div>
      </div>
    ) : null}
  </section>
);

export default FiltersPanel;
